import { Component, OnInit, Input, OnChanges } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';

import { SchemaTableauModel, DonneeTableauModel } from '~Models/schema-tableau-model';

/**
 * Composant tableau
 * @extends BaseComponent
 * @implements OnInit, OnChanges
 */
@Component({
  selector: 'app-tableau',
  templateUrl: './tableau.component.html',
  styleUrls: ['./tableau.component.scss']
})
export class TableauComponent extends BaseComponent implements OnInit, OnChanges {

    @Input() schema: SchemaTableauModel = null;
    @Input() donnees: any[] = null;

    liste: DonneeTableauModel[] = [];

    private filtres: boolean[] = [];

    /**
     * Constructeur
     */
    constructor() { super(); }

    /**
     * Initialiser le composant
     */
    ngOnInit() {
    }

    /**
     * Changements
     */
    ngOnChanges() {
        this.liste = [];
        this.filtres = [];

        if (this.schema && this.donnees) {

            let colonnes = this.schema.Colonnes;
            let donnees = this.donnees;

            for (let i = 0; i < donnees.length; i++) {

                // Initialise la liste
                this.liste[i] = {
                    Colonnes: [],
                    CssClass: donnees[i]['_cssClass'] || ''
                }

                // Pour chaque colonne
                for (let j = 0; j < colonnes.length; j++) {
                    let colonne = colonnes[j];

                    // R�cup�re les donn�es
                    let valeur: any = donnees[i][colonne.Nom];
                    let libelle: string = valeur;
                    let type = colonne.Type;

                    // Type date
                    if (colonne.Type == 'date') {
                        libelle = (valeur as Date).toLocaleDateString();
                    }

                    // Ajout aux colonnes
                    this.liste[i].Colonnes.push({
                        Libelle: libelle,
                        Valeur: valeur,
                        Type: type
                    });
                }
            }
        }
    }

    /**
     * Changer l'�tat du tri d'une colonne
     * @param index
     * @param etat
     */
    changerEtatTri(index: number, etat: boolean) {
        this.filtres[index] = etat;
    }

    /**
     * Trier la liste sur une colonne
     * @param index
     */
    trier(index: number) {
        // R�cup�re l'ordre de tri
        let ordreTri: boolean = !!this.filtres[index];

        // R�initialise les filtres
        this.filtres = [];

        // Tri de la liste
        this.liste = this.liste.sort((a, b) => {
            if (a.Colonnes[index].Valeur > b.Colonnes[index].Valeur) {
                return ordreTri ? 1 : -1;
            }
            else {
                return ordreTri ? -1 : 1;
            }
        });

        // Indique le nouvel ordre de tri pour le prochain tri
        this.filtres[index] = !ordreTri;
    }
}
